import { LayoutRules } from "@buildwithflux/models";
import { humanizeRotationValue } from "@buildwithflux/shared";
import { cloneDeep } from "lodash";
/**
 * Take a node and return a new pcbNodeRuleSet based on the prior one modified by
 * updatedRotation.
 */
export function updateNodeRotationRules(node, updatedRotation, defaultToZRule = true) {
    // NOTE: previously we used ImmerJS here but if the values stayed exactly
    // the same produce would return a draft
    const pcbNodeRuleSet = cloneDeep(node.pcbNodeRuleSet);
    const xRotationValue = humanizeRotationValue(updatedRotation.x, node.bakedRules?.rotationUnit);
    const yRotationValue = humanizeRotationValue(updatedRotation.y, node.bakedRules?.rotationUnit);
    const zRotationValue = humanizeRotationValue(updatedRotation.z, node.bakedRules?.rotationUnit);
    if (!pcbNodeRuleSet.rotationX || !pcbNodeRuleSet.rotationY || !pcbNodeRuleSet.rotationZ) {
        if (defaultToZRule) {
            if (pcbNodeRuleSet.rotationZ) {
                pcbNodeRuleSet.rotationZ.value = zRotationValue;
                pcbNodeRuleSet.rotationZ.disabled = false;
            }
            else {
                pcbNodeRuleSet.rotationZ = {
                    uid: LayoutRules.rotationZ.key,
                    key: LayoutRules.rotationZ.key,
                    value: zRotationValue,
                    disabled: false,
                };
            }
        }
        else {
            if (pcbNodeRuleSet.rotation) {
                pcbNodeRuleSet.rotation.value = `${xRotationValue} ${yRotationValue} ${zRotationValue}`;
                pcbNodeRuleSet.rotation.disabled = false;
            }
            else {
                pcbNodeRuleSet.rotation = {
                    uid: LayoutRules.rotation.key,
                    key: LayoutRules.rotation.key,
                    value: `${xRotationValue} ${yRotationValue} ${zRotationValue}`,
                    disabled: false,
                };
            }
        }
        if (pcbNodeRuleSet.rotationX) {
            pcbNodeRuleSet.rotationX.value = xRotationValue;
            pcbNodeRuleSet.rotationX.disabled = false;
        }
        if (pcbNodeRuleSet.rotationY) {
            pcbNodeRuleSet.rotationY.value = yRotationValue;
            pcbNodeRuleSet.rotationY.disabled = false;
        }
        if (pcbNodeRuleSet.rotationZ) {
            pcbNodeRuleSet.rotationZ.value = zRotationValue;
            pcbNodeRuleSet.rotationZ.disabled = false;
        }
    }
    else {
        if (pcbNodeRuleSet.rotationX) {
            pcbNodeRuleSet.rotationX.value = xRotationValue;
            pcbNodeRuleSet.rotationX.disabled = false;
        }
        else {
            pcbNodeRuleSet.rotationX = {
                uid: LayoutRules.rotationX.key,
                key: LayoutRules.rotationX.key,
                value: xRotationValue,
                disabled: false,
            };
        }
        if (pcbNodeRuleSet.rotationY) {
            pcbNodeRuleSet.rotationY.value = yRotationValue;
            pcbNodeRuleSet.rotationY.disabled = false;
        }
        else {
            pcbNodeRuleSet.rotationY = {
                uid: LayoutRules.rotationY.key,
                key: LayoutRules.rotationY.key,
                value: yRotationValue,
                disabled: false,
            };
        }
        if (pcbNodeRuleSet.rotationZ) {
            pcbNodeRuleSet.rotationZ.value = zRotationValue;
            pcbNodeRuleSet.rotationZ.disabled = false;
        }
        else {
            pcbNodeRuleSet.rotationZ = {
                uid: LayoutRules.rotationZ.key,
                key: LayoutRules.rotationZ.key,
                value: zRotationValue,
                disabled: false,
            };
        }
    }
    return pcbNodeRuleSet;
}
//# sourceMappingURL=updateNodeRotationRules.js.map